import React from "react";
import PhotoCard from "./components/PhotoCard";
import "./App.css";

function App() {
  return (
    <div className="App">
      <PhotoCard />
    </div>
  );
}

export default App;
